export const enFaq = [
  {
    question: "How long is the information available?",
    response: (
      <div>
        The information is available in the run-up to the surgery and <u>up to 24 hours after</u> the end of the
        surgery, i.e. after the patient leaves the surgical unit
      </div>
    ),
  },
  {
    question: "What information is displayed?",
    response: (
      <>
        <div>
          The information is displayed after the surgery has been scheduled. If the search is performed before the
          surgery is scheduled, the system returns an error message. The same message is displayed if more than 24 hours
          have passed since leaving the surgery unit.
        </div>
        <br />
        <div>
          The information available relates to the patient's progress through the main time phases of the surgery, in
          sequence:
        </div>
        <div className="sequenzaStati">
          <span>Entry into the surgical unit</span>
          <span>Entry into the operating theatre</span>
          <span>Exit from the operating theatre</span>
          <span>Exit from the surgical unit</span>
        </div>
        <br />
        <div>
          Each event in the sequence is associated with the time the event occurred, if available and in the past
        </div>
        <br />
        <div>The patient's progress in the sequence is also displayed</div>
      </>
    ),
  },
  {
    question: "What are the possible states of progress?",
    response: (
      <div>
        The sequence of possible progress states is:
        <div className="sequenzaStati">
          <span>
            "Planned surgery": the surgery has been included in the planning but has not yet started, no time is given,
            all events are "not yet started"
          </span>
          <span>
            "In the surgical unit": the patient has been transferred to the surgical unit but the surgical event has not
            yet started, the time of entry into the surgical unit is displayed
          </span>
          <span>
            "Surgery in progress": the surgical event is in progress, the time of entry into the operating theatre is
            displayed
          </span>
          <span>
            "Post-surgery": the patient is still in the surgery unit, the time of exit from operating theatre is
            displayed
          </span>
          <span>
            "Surgery completed": the patient has left the surgey unit and is being transferred or is already in the
            ward; the time of exit from the surgery unit is displayed
          </span>
        </div>
      </div>
    ),
  },
  {
    question: "What is the meaning of the indicators along the displayed timeline?",
    response: (
      <div>
        The indicators can take on three values "not yet started", "in progress", "finished", which refer to the step in
        the sequence immediately following the event.
        <br />
        If the event has not yet occurred, the indicator takes the value "not yet started". If the event has occurred
        but the next event has not yet occurred, the indicator takes the value "in progress". If the next event in the
        timeline has already occurred, the indicator takes the value "completed".
      </div>
    ),
  },
];
